import { ActionType } from '../index';
import { AUTH_MUTATION } from '../mutations/mutationTypes';
import { AUTH_ACTION } from './actionTypes';
import { axios } from '@/plugins/axios';
import { ResponseUser } from '@/shared/types/entities/User';
import { endPoints, Params } from '@/shared/types/api';
import { useNotification } from '@/shared/hooks/useNotification';
import vueRouter from '@/router';

export type LoginPayload = {
  password: string;
  is_admin: 1 | 0;
};

export const authActions = {
  [AUTH_ACTION.LOGIN]: async (
    { commit }: ActionType,
    payload: LoginPayload,
  ) => {
    const { showNotification } = useNotification();
    axios.post(endPoints.login.endPoint, { ...payload }).then(() => {
      axios.get(endPoints.getUserInfo.endPoint).then((res) => {
        commit(AUTH_MUTATION.GET_USER, res.data.items);
        showNotification({
          isShow: true,
          message: 'ログインしました',
          type: 'success',
        });

        const pathname = window.location.pathname;
        if (pathname.includes('admin')) {
          vueRouter.push('/admin/result-publication/schools');
        } else {
          vueRouter.push('/user/result-publication/rehearsal');
        }
      });
    });
  },
  [AUTH_ACTION.LOGOUT]: ({ commit }: ActionType) => {
    return commit(AUTH_MUTATION.LOGOUT);
  },
  [AUTH_ACTION.GET_USER]: async ({ commit }: ActionType) => {
    const res: { items: ResponseUser } = await axios.get(
      endPoints.getUserInfo.endPoint,
    );

    commit(AUTH_MUTATION.GET_USER, res.items);
  },
  [AUTH_ACTION.UPDATE_PASSWORD]: async (
    { commit }: ActionType,
    payload: Params<'savePassword'> & { confirmPassword: string },
  ) => {
    const { showNotification } = useNotification();

    const { organization_ids, password, confirmPassword } = payload;

    if (password !== confirmPassword) {
      return showNotification({
        isShow: true,
        message: 'パスワードが一致していません',
        type: 'error',
      });
    } else {
      await axios
        .post(endPoints.savePassword.endPoint, { organization_ids, password })
        .then(() => {
          showNotification({
            isShow: true,
            message: 'パスワードを変更しました',
            type: 'success',
          });
          vueRouter.back();
        })
        .catch(() => {
          showNotification({
            isShow: true,
            message: 'パスワードを変更できませんでした',
            type: 'error',
          });
        });
    }
  },
};
